<script setup>
import { onMounted, watch } from 'vue';
import { useAuthStore } from '@/stores/auth';
import { echo } from '@/utils/echo';
import { useRouter } from 'vue-router';

// IMPORT SERVICE LU DI SINI SAJA
import { axiosService } from '@/utils/axiosService'; // Sesuaikan path file axios lu

const auth = useAuthStore();
const router = useRouter();

// ========================================================
// INJEKSI CUSTOM AUTHORIZER ECHO DARI LUAR
// ========================================================
echo.connector.pusher.config.authorizer = (channel, options) => {
  return {
    authorize: async (socketId, callback) => {
      try {
        // Tembak pake axiosService lu langsung di sini!
        const response = await axiosService.apiRest('/broadcasting/auth', {
          method: 'POST',
          data: {
            socket_id: socketId,
            channel_name: channel.name
          }
        });

        callback(false, response.data);
      } catch (error) {
        console.error('Reverb Auth Ditolak:', error);
        callback(true, error);
      }
    }
  };
};
// ========================================================


watch(() => auth.BoUser, (newUser) => {
  if (newUser) {
    const targetUid = newUser.useruid;

    if (targetUid) {
      const channelName = `bo-session.${targetUid}`;

      echo.leave(channelName);

      echo.private(channelName)
        .listen('.account.kicked', (data) => {

          globalThis.Swal.fire({
            icon: 'warning',
            title: 'Sesi Berakhir',
            text: 'Anda telah keluar karena akun ini baru saja login dari perangkat atau browser lain.',
            allowOutsideClick: false,
          }).then(() => {
            auth.logoutUserToken();
            setTimeout(() => { window.location.reload(); }, 500);
          });
        });
    } else {
      console.error("User Object ada, tapi UID/ID-nya KOSONG! Cek struktur datanya.");
    }
  }
}, { immediate: true, deep: true });
</script>

<template>
  <RouterView />
</template>

<style scoped></style>
